import { createContext, useState } from "react"

const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({})

    if (!auth?.user) {
        const local = JSON.parse(localStorage.getItem('user'))

        if (local) {
            setAuth({ user: local })
        }
    }

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext